module.exports = __webpack_public_path__ + "img/svg/column.dcbc827f40dadd3f4a993351c72b7f0f.svg";